import { _js } from '@ifixit/localize';
import styled from 'styled-components';
import { color } from '@core-ds/primitives';
import { Bell, BellSolid } from '@core-ds/icons/24';
import Dropdown from './dropdown';
import NotificationsDisplay from './notifications_display';
import Notifications from 'Shared/Notifications/notifications';

const Icon = styled(Bell)`
   cursor: pointer;
   color: ${color.gray[400]};
`;

const UnreadIcon = styled(BellSolid)`
   cursor: pointer;
   color: ${color.gray[50]};
`;

function NotificationsDropdown({
   notifications,
   notificationsUrl,
}: {
   notifications: Notifications;
   notificationsUrl: string;
}) {
   const unreadNotifications = notifications.getUnreadNotifications();
   const hasUnread = unreadNotifications.length != 0;

   const dropdownIcon = hasUnread ? <UnreadIcon focusable="false" /> : <Icon focusable="false" />;
   const label = hasUnread ? 'unread notifications dropdown' : 'notifications dropdown';

   return (
      <Dropdown label={label} icon={dropdownIcon} hasBadge={hasUnread}>
         {hasUnread ? (
            <NotificationsDisplay
               unreadNotifications={unreadNotifications}
               notificationsUrl={notificationsUrl}
               markAllRead={notifications.markAllRead}
            />
         ) : (
            <p style={{ display: 'flex', justifyContent: 'center', padding: '0 8px 0 8px' }}>
               {_js('No notifications!')}
            </p>
         )}
      </Dropdown>
   );
}

export default NotificationsDropdown;
